
require("./../../node_modules/@module-federation/nextjs-mf/src/include-defaults.js");
/* eslint-disable prefer-destructuring */
/* eslint-disable no-sequences */
/* eslint-disable react/prop-types */
/* eslint-disable array-callback-return */
/* eslint-disable no-unused-expressions */
/* eslint-disable default-case */
import MainLayout from 'global/MainLayout';
import useProtectedRoute from 'hooks/useProtectedRoute';
import { getUnboxingDetail } from 'lib/api/academy';
import SEO from 'global/SEO';

import { STOCKBIT_ACADEMY_URL } from 'constants/api';
import { isMobile, isUsingInstagram } from 'utils/serverside';
import { escape } from 'querystring';
import dynamic from 'next/dynamic';
import { trimText } from 'utils/general';

const Academy = dynamic(() => import('features/academy'), { ssr: false });
const PageLoader = dynamic(() => import('global/Loading/PageLoader'), {
  ssr: false,
});

function UnboxingPage(props) {
  const { isLoaded } = useProtectedRoute();
  const { head } = props;

  return (
    <MainLayout isFlexibleWidth background="white">
      <SEO
        description={head.description}
        image={head.image}
        title={head.title}
      />
      <PageLoader loaded={isLoaded} />
      <Academy />
    </MainLayout>
  );
}

export async function getServerSideProps(context) {
  const {
    query: { slugs = [], ...restQuery },
    req: { headers, url },
  } = context;
  const { token = '', theme = 'light', source: sourceQuery } = restQuery;
  const userAgent = headers['user-agent'];
  const isFromMobile = isMobile(userAgent);
  const isFromInstagram = isUsingInstagram(userAgent);
  const sourceKey = escape(sourceQuery);
  const source = sourceKey !== 'undefined' ? sourceKey : 'deeplink';
  const pathname = slugs.join('/');

  let unboxingId = null;
  let redirectUrl = null;

  //- /unboxing/{unboxingId}
  if (/\d+/i.test(pathname)) {
    unboxingId = slugs[0];
    redirectUrl = `/unboxing/volume/${unboxingId}`;
  }

  //- /unboxing/volume/{unboxingId}
  if (/volume\/\d+/i.test(pathname)) {
    unboxingId = slugs[1];
    redirectUrl = null;
  }

  if (/unboxingsaham(?:)/i.test(url)) {
    redirectUrl = '/unboxing';
  }

  if (/unboxingsaham\/\d+/i.test(url)) {
    unboxingId = url.split('/unboxingsaham/')[1].replace('/', '');
    redirectUrl = `/unboxing/volume/${unboxingId}`;
  }

  redirectUrl =
    isFromMobile || isFromInstagram
      ? `/unboxing/${unboxingId || ''}`
      : redirectUrl;

  const metaData =
    unboxingId !== null
      ? await getUnboxingDetail(unboxingId)
          .then((res) => res.json())
          .then((res) => {
            const unboxingData = res.data;
            return {
              description: trimText(unboxingData.description, 160),
              title: unboxingData.title,
              image: unboxingData.thumbnail_url,
            };
          })
          .catch(() => {
            return {
              description: null,
              title: 'Stockbit Academy',
              image: null,
            };
          })
      : {
          description: null,
          title: 'Stockbit Academy',
          image: null,
        };

  const BASE_URL = isFromMobile || isFromInstagram ? STOCKBIT_ACADEMY_URL : '';
  const queryString: any =
    isFromMobile || isFromInstagram ? { token, theme, source } : {};
  const parsedQueryString = new URLSearchParams(queryString);

  const redirect =
    redirectUrl !== null
      ? {
          permanent: false,
          destination: `${BASE_URL}${redirectUrl}?${parsedQueryString.toString()}`,
        }
      : false;
  return {
    redirect,
    props: {
      head: {
        ...metaData,
      },
      redirect, // For debugging
      redirectUrl,
    },
  };
}

export default UnboxingPage;
